import { Event, Interface, Method } from '@central-products/transport-bus-common';
import { SessionServiceState, OnSessionServiceStateChangedCallback } from './interfaces';

@Interface('common', 'sessionService')
export class SessionServiceInterface {
  @Method('state.get')
  public getState(): Promise<SessionServiceState> {
    throw new Error('Method is not implemented yet');
  }

  @Event('state.changed')
  public onStateChanged(_callback: OnSessionServiceStateChangedCallback): void {
    throw new Error('Event is not implemented yet');
  }
}
